import { render, staticRenderFns } from "./liveTab.vue?vue&type=template&id=c6f4955c&"
import script from "./liveTab.vue?vue&type=script&lang=js&"
export * from "./liveTab.vue?vue&type=script&lang=js&"
import style0 from "./liveTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports